/*
* @Author: zhangzhitao
* @Date: 2019-05-20 17:02:21
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-07-09 17:10:33
*/

<template>
  <div
    class="m-outer"
    ref="filterOuter"
  >
    <div
      class="m-inner"
      @click="handleSwitchFilterBox"
    >
      <el-scrollbar wrap-class="m-scroll-wrap">
        <span
          class="u-tag brand-bg-color"
          v-for="(tag,index) in aTags"
          v-show="tag.isActive"
          :key="index"
        >{{tag.value}}
          <i
            class="h-icon-close"
            @click.stop="handleTagSelect(tag,index)"
          ></i>
        </span>
        <span
          class="u-placehoder"
          v-show="actTagsLength===0"
        >{{$t('management.dataView.check_widget_type')}}</span>
      </el-scrollbar>
    </div>
    <i
      class="u-icon-down"
      :class="{'h-icon-angle_down':!filterBox,'h-icon-angle_up':filterBox}"
      @click="handleSwitchFilterBox"
    ></i>
    <div
      class="m-filter-box"
      id="filterBox"
      v-show="filterBox"
    >
      <span
        class="u-tag"
        v-for="(tag,index) in aTags"
        :key="index"
        :class="{'brand-bg-color':tag.isActive,'u-tag-unselect':!tag.isActive}"
        @click="handleTagSelect(tag,index)"
      >
        {{tag.value}}</span>
      <span
        class="u-no-tags"
        v-show="aTags.length===0"
      >{{$t('management.dataView.has_none_widget_type')}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tag-filter',
  props: {
    tags: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      actTags: [],
      filterBox: false,
      aTags: []
    }
  },

  components: {

  },

  computed: {
    actTagsLength () {
      let arrActTags = []
      this.aTags.forEach(tag => {
        if (tag.isActive) arrActTags.push(tag)
      })
      return arrActTags.length
    }
  },

  mounted () { },

  methods: {
    removeTag (i) {
      this.actTags.splice(i, 1)
    },
    // 筛选框展开关闭
    handleSwitchFilterBox () {
      this.filterBox = !this.filterBox
      if (this.filterBox) {
        let filterOuter = this.$refs.filterOuter
        document.getElementById('filterBox').style.top = filterOuter.offsetHeight + 5 + 'px'
      }
    },
    handleTagSelect (tag, index) {
      let temp = this.aTags[index]
      temp.isActive = !temp.isActive
      this.$set(this.aTags, index, temp)
    }
  },
  watch: {
    tags: {
      handler () {
        this.tags.forEach(tag => {
          this.aTags.push({
            value: tag,
            isActive: false
          })
        })
      },
      deep: true
    },
    aTags: {
      handler () {
        let actives = []
        this.aTags.forEach(tag => {
          if (tag.isActive) {
            actives.push(tag.value)
          }
        })
        if (actives.length > 0) {
          this.$emit('filter', actives.join(','))
        }
        this.$nextTick(() => {
          let filterOuter = this.$refs.filterOuter
          document.getElementById('filterBox').style.top = filterOuter.offsetHeight + 5 + 'px'
        })
      },
      deep: true
    }
  }
}

</script>

<style lang="less" scoped>
.m-outer {
  position: relative;
  width: calc(~"100% - 32px");
  background: rgba(255, 255, 255, 0.12);
  border-radius: 2px;
  padding: 0 2px;
  margin: 24px auto;
  border: 1px solid transparent;
  .m-inner {
    width: 100%;
    min-height: 32px;
    overflow: hidden;
    cursor: pointer;
    .u-placehoder {
      color: rgba(255, 255, 255, 0.3);
      line-height: 32px;
      margin-left: 8px;
    }
  }
  &:hover {
    border: 1px solid rgba(255, 255, 255, 0.7);
  }
  .m-filter-box {
    position: absolute;
    width: 286px;
    left: 0;
    max-height: 276px;
    padding: 16px;
    box-sizing: border-box;
    background: #454545;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 2px;
    z-index: 9;
    .u-no-tags {
      width: 100%;
      display: inline-block;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
    }
  }
  .u-tag-unselect {
    background: rgba(255, 255, 255, 0.12);
    cursor: pointer;
  }
  .u-icon-down {
    display: block;
    width: 24px;
    height: 24px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    position: absolute;
    right: 8px;
    top: 50%;
    margin-top: -12px;
    cursor: pointer;
  }
  /deep/ .m-scroll-wrap {
    max-height: 101px;
  }
  // /deep/ .u-search-ipt {
  //   min-width: 120px;
  //   max-width: 280px;
  //   width: auto;
  //   display: inline-block;
  // }
  .u-tag {
    display: inline-block;
    padding: 0 8px;
    line-height: 24px;
    color: #fff;
    border-radius: 2px;
    margin: 4px 2px;
    i {
      cursor: pointer;
    }
  }
}
</style>
